<style>
	.edi-main .info {
		font-size: 1.2em;
		position: relative;
		background-color: #fff;
	}
	.edi-main .info .num,
	.edi-main .info .msg,
	.edi-main .main .msg {
		display: block;
		text-align: center;
	}

	.edi-main .info .green {
		color: #999900;
	}
	.edi-main .info .red {
		color: #d15b47;
	}
	.edi-main .info .msg {
		margin-top: 0.3em;
		font-size: .8em
	}
	.edi-main .info a {
		display: block;
		padding: 1em 0;
		margin-left: 30px;
	}
	.edi-main .info .left {
		background: url('../assets/home/none.png') no-repeat 18px center;
		background-size: 30px;
	}
	.edi-main .info .right {
		background: url('../assets/home/wait.png') no-repeat 18px center;
		background-size: 30px;
		text-align: right;
	}
	.edi-main .info .left a {
		border-right: 1px #cecece solid;
	}
	.edi-main .main {
		position: relative;
		background: url('../assets/home/count.png') no-repeat 18px center;
		background-size: 30px;
		border-top: 1px #cecece solid;
		background-color: #fff;
	}
	.edi-main .main a {
		display: block;
		padding: 1em 0;
		margin-left: 62px;
	}
	.edi-main .main .msg {
		font-size: 1em;
		text-align: left;
	}
	.edi-main .main1 {
		position: relative;
		background: url('../assets/home/i-total.png') no-repeat 18px center;
		background-size: 30px;
		border-bottom: 1px #cecece solid;
		background-color: #fff;
		top:-2px;
	}
	.edi-main .main2 {
		position: relative;
		background: url('../assets/home/i-money-summary.png') no-repeat 18px center;
		background-size: 30px;
		border-bottom: 1px #cecece solid;
		background-color: #fff;
		top:-2px;
	}
	.edi-main.home-page {
		flex: 1;
		display: flex;
    	flex-direction: column;
	}
	.main-banner {
    	flex: 1;
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}
</style>
<template>
	<div class="edi-main home-page">
		<div class="info">
			<div class="ui-col-5 left">
				<router-link :to="{ path: '/all-order-bill', query: { bill_state:'10', 'bill_font': '未处理'}}">
					<span class="num green" v-show="countShow(count.order_unhandled_num)">{{count.order_unhandled_num}}张</span>
					<span class="msg">未处理订单</span>
				</router-link>
			</div
			><div class="ui-col-5 right">
				<router-link :to="{ path: '/all-order-bill', query: { bill_state:'11', 'bill_font': '待发货'}}">
					<span class="num red" v-show="countShow(count.order_accept_num)">{{count.order_accept_num}}张</span>
					<span class="msg">待发货订单</span>
				</router-link>
			</div>
		</div>
		<div class="main">
			<router-link :to="{path: '/bill-count', query: { bill_state: '12,21', end_date: end_date, length: 10, restaurant_id: '', start: 0, start_date: start_date }}" class="ui-btn-icon-right ui-icon-carat-r">
				<span class="msg">单据统计</span>
			</router-link>
		</div>
		<div class="main main1">
			<router-link :to="{path: '/goods-company-summary'}" class="ui-btn-icon-right ui-icon-carat-r">
				<span class="msg">货品汇总</span>
			</router-link>
		</div>
		<div class="main main2">
			<router-link :to="{path: '/goods-money-summary'}" class="ui-btn-icon-right ui-icon-carat-r">
				<span class="msg">金额汇总</span>
			</router-link>
		</div>
		<div class="main main1">
			<router-link :to="{path: '/goods-company-summary', query: { shortcut: 1 }}" class="ui-btn-icon-right ui-icon-carat-r">
				<span class="msg">今日货品汇总</span>
			</router-link>
		</div>
		<div class="main-banner fx-festival-home-banner"></div>
		<tips v-show="tips" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatus"></tips>
		<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
	</div>
</template>
<!--{{{ script -->
<script>
import Tips from '../components/Tips'
import TipsAuto from '../components/TipsAuto'
import { GlobalStore } from '../store/globalStore'
export default {
	data () {
		return {
			msg: [],
			tips: false,
			tipsauto: false,
			btnNum: 1,
			tipsFont: '',
			start_date: '',
			end_date: '',
			count: {},
			sec: 1500,
			store: GlobalStore
		}
	},
	components: {
		'tips': Tips,
		'tips-auto': TipsAuto
	},
	created () {
		this.storeHandle()
		// 如果筛选条件更改过,清空筛选条件 shang 2017/10/19
		if (this.store.billFilterData.filterFlag) {
			this.filterHandle()
		}
		this.$http.get('/cldEdi/business/billCount').then(response => {
			this.count = response.body.data
			// window.console.log(this.count)
		}, (response) => {
			var self = this
			self.tipsauto = true
			self.tipsFont = '服务中断，稍后请重试！'
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		})
		var d = new Date()
		var year = d.getFullYear()
		var month = d.getMonth() + 1
		if (month < 10) {
			month = '0' + month
		}
		this.start_date = year + '-' + month + '-' + '01'
		var day = new Date(year, month, 0)
		this.end_date = year + '-' + month + '-' + day.getDate()
		// this.end_date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
	},
	methods: {
		storeHandle () {
			this.store.goodsTotalInfo = {}
			this.store.goodsTotalInfo.filterShow = true
			// window.console.log(this.store.goodsTotalInfo)
		},
		filterHandle () {
			this.store.billFilterData.filterFlag = false
			this.store.billFilterData.filterBillState = ''
			this.store.billFilterData.filterBillStateFont = ''
			this.store.billFilterData.filterStartDate = ''
			this.store.billFilterData.filterEndDate = ''
			this.store.billFilterData.filterBillSort = ''
			this.store.billFilterData.filterBillSortFont = ''
		},
		tipStatus (msg) {
			this.tips = msg[0]
		},
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		countShow (val) {
			if (val === 0) {
				return false
			} else {
				return true
			}
		}
	}
}
</script>
<!--}}}-->



// WEBPACK FOOTER //
// Home.vue?4779cf47